
<template>
  <div class="container">
    <CommonFrame :workNo="workNo"
                  :btns="btns"
                  :node="node"
                  :breadcrumb="breadcrumb"
                  :endStatus="approvalParams.endStatus"
                  :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="商品信息">
            <lk-table border :columns='columns' :data='tableData'></lk-table>
          </lk-card>
        </div>

        <div class="cardContainer" v-if="saleBuyerInfo">
          <lk-form
            label-position="right"
            :label-width="140"
          >
            <lk-card title="购买者信息">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="购买者姓名:">
                    <span>{{this.saleBuyerInfo.buyerName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="购买者年龄:">
                    <span>{{this.saleBuyerInfo.buyerAge}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" >
                  <lk-form-item label="性别:">
                    <span>{{ this.gender[this.saleBuyerInfo.buyerGender]}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" >
                  <lk-form-item label="证件号码:">
                      <CredentialsInput :able='false' v-model.trim='this.saleBuyerInfo' codeKey="buyerIdCard" ></CredentialsInput>

                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="联系方式:">
                    <span>{{this.saleBuyerInfo.buyerPhone}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" >
                  <lk-form-item label="购买原因:">
                    <span>{{this.saleBuyerInfo.buyerReason}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </lk-form>
        </div>

        <!-- <div class="cardContainer" v-if="salePrescription">
          <lk-form
            label-position="right"
            :label-width="140"
          >
            <lk-card title="处方信息">
              <lk-row :gutter="16">
                <lk-col span="10">
                  <lk-form-item label="处方单号:">
                    <span>{{this.salePrescription.prescriptionNo}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="联系方式:">
                    <span>{{this.salePrescription.patientPhone}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" >
                  <lk-form-item label="姓名:">
                    <span>{{this.salePrescription.patientName}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" >
                  <lk-form-item label="处方医院:">
                    <span>{{this.salePrescription.prescriptionHospital}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                  <lk-form-item label="患者年龄:">
                    <span>{{this.salePrescription.patientAge}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" >
                  <lk-form-item label="处方医生:">
                    <span>{{this.salePrescription.prescriptionDoctor}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10" >
                  <lk-form-item label="诊断说明:">
                    <span>{{this.salePrescription.diseaseName}}</span>
                  </lk-form-item>
                </lk-col>

                <lk-col span="10" >
                  <lk-form-item label="诊断补充说明:">
                    <span>{{this.salePrescription.additionalRemark}}</span>
                  </lk-form-item>
                </lk-col>

                <lk-col span="22" >
                  <lk-form-item label="处方商品:">
                    <lk-table border :data='listUsage' :columns='RXColumns'></lk-table>
                  </lk-form-item>
                </lk-col>

                <lk-col span="10" >
                  <lk-form-item label="调配人:">
                    <span>{{this.salePrescription.allocaterName}}</span>
                  </lk-form-item>
                </lk-col>

                <lk-col span="10" >
                  <lk-form-item label="复核人:">
                    <span>{{this.salePrescription.reviewerName}}</span>
                  </lk-form-item>
                </lk-col>

              </lk-row>
            </lk-card>
          </lk-form>
        </div> -->
<div class="cardContainer"  v-if="salePrescription">
 <prescriptionDecoction v-if='goodsType===3' v-model="salePrescription"
            :able='false'></prescriptionDecoction>
          <prescriptionCommon v-else v-model="salePrescription" :able='false'  :showSpec='false'></prescriptionCommon>

</div>
        <div class="cardContainer">
          <lk-form
            label-position="right"
            :label-width="140"
          >
            <lk-card title="订单信息">
              <lk-row :gutter="16">
                <lk-col span='7'>
                  <lk-form-item label="订单编号:">
                    <span>{{this.saleOrder.orderNo}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7' offset='1'>
                  <lk-form-item label="应收金额（元）:">
                    <span>{{this.saleOrder.totalAmountDisplay}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7' offset='1'>
                  <lk-form-item label="实收金额（元）:">
                    <span style="fontSize:16px;color:#2d8cf0">{{'￥'+this.saleOrder.proceedsAmount}}</span>
                  </lk-form-item>
                </lk-col>
              <lk-row :gutter="16">
              </lk-row>
                <lk-col span='7' >
                  <lk-form-item label="找零（元）:">
                    <span>{{this.saleOrder.proceedsAmount>this.saleOrder.totalAmountDisplay?(this.saleOrder.proceedsAmount-this.saleOrder.totalAmountDisplay).toFixed(2):0}}</span>
                  </lk-form-item>
                </lk-col>
                <lk-col span='7' offset='1'>
                    <lk-form-item label='剩余应收:'>
                    <span>{{(saleOrder.totalAmountDisplay > saleOrder.proceedsAmount) ? (saleOrder.totalAmountDisplay-saleOrder.proceedsAmount).toFixed(2) : 0}}</span>

                   </lk-form-item>
                  </lk-col>
                 <lk-col span='7' offset='1'>
                  <lk-form-item label="订单类型:">
                    <span>{{this.saleOrder.type}}</span>
                  </lk-form-item>
                </lk-col>

              </lk-row>
              <lk-row :gutter="16">
                <lk-col span='7' :key="index" v-for="(item,index) in paymentList" :offset='index%3===0?0:1'>
                  <lk-form-item :label="item.proceedsTypeName+':'">
                    <span>{{item.amount}}</span>
                  </lk-form-item>


                </lk-col>
            </lk-row>
              <lk-row :gutter="16">
                <lk-col span='7' >
                  <lk-form-item label="取消原因:">
                    <span>{{this.saleOrder.cancelReason}}</span>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </lk-form>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>
<script>

import axios from 'axios';
import utils from '@/libs/utils';
import system from '@/services/system';
import CommonFrame from '../commonFrame.vue';
import prescriptionCommon from '../../../components/prescription/Common.vue';
import prescriptionDecoction from '../../../components/prescription/Decoction.vue';

import CredentialsInput from '../../../components/CredentialsInput';

export default {
  name: 'cancelOrderFlowInfo',
  components: {
    CommonFrame, prescriptionCommon, prescriptionDecoction, CredentialsInput,
  },
  props: {
    approvalParams: {
      type: Object,
    },
  },
  data() {
    return {
      goodsType: null,
      workNo: '',
      node: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '订单取消审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      saleOrder: {},
      type: [null, '店内购买', '配送'],
      bool: ['', '是', '否'],
      gender: ['', '男', '女'],
      columns: [
        { title: '序号', key: 'number', minWidth: 116 },
        { title: '门店', key: 'storeName', minWidth: 116 },
        { title: '销售单号', key: 'orderNo', minWidth: 116 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '商品名称', key: 'goodsName', minWidth: 116 },
        { title: '通用名称', key: 'approvedDrugNames', minWidth: 116 },
        { title: '行号', key: 'lineNum', minWidth: 116 },
        { title: '处方药', key: 'isRX', minWidth: 116 },
        { title: '含麻药', key: 'isEphedrine', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '剂型', key: 'dosageForm', minWidth: 116 },
        { title: '供应商', key: 'supplierName', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '销售单价', key: 'retailPrice', minWidth: 116 },
        { title: '单位', key: 'goodsUnit', minWidth: 116 },
        { title: '仓库', key: 'storehouseName', minWidth: 116 },
        { title: '货位', key: 'allocationName', minWidth: 116 },
        { title: '批次', key: 'goodsBatch', minWidth: 116 },
        { title: '批号', key: 'goodsLot', minWidth: 116 },
        { title: '实际单价', key: 'realPrice', minWidth: 116 },
        { title: '销售数量', key: 'goodsCount', minWidth: 116 },
        { title: '税率', key: 'outputTaxRate', minWidth: 116 },
        { title: '含税金额', key: 'amount', minWidth: 116 },
        { title: '不含税金额', key: 'totalPriceAfterTax', minWidth: 116 },
        { title: '销售时间', key: 'createTime', minWidth: 116 },
        { title: '营业员', key: 'createUserName', minWidth: 116 },
      ],
      saleBuyerInfo: null,
      salePrescription: null,
      RXColumns: [
        { title: '商品名称', key: 'approvedDrugNames', minWidth: 116 },
        { title: '购买数量', key: 'goodsCount', minWidth: 116 },
        { title: '用法', key: 'goodsUsage', minWidth: 116 },
        { title: '用量', key: 'goodsDosage', minWidth: 116 },
      ],
      tableData: [],
      paymentList: [],

    };
  },
  methods: {
    getPayment() {
      return new Promise((resolve) => {
        system.getStoreProceedsTypeList({ status: 1 }).then((res) => {
          if (res.data.status === 200) {
            this.paymentList = res.data.data.list;
            resolve();
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        const item = res.data.data.saleOrder;
        this.goodsType = res.data.data.goodsType;
        const result = [];
        // utils.exchangeTable(item, result);
        item.createTime = utils.exchangeTime(result.createTime);
        // item.proceedsAmount = utils.exchangePercent(item.proceedsAmount);
        // item.paymentCash /= 100;
        // item.paymentWechat /= 100;
        // item.paymentAlipay /= 100;
        // item.paymentUnionpay /= 100;
        // item.paymentPrepay /= 100;
        // item.totalAmount /= 100;
        this.paymentList = res.data.data.saleOrderProceedsList;
        // this.paymentList.forEach((el) => {
        //   el.amount = utils.exchangePercent(el.amount);
        // });
        item.type = this.type[item.type];
        item.loading = false;
        // this.saleOrder = item;
        this.saleOrder = utils.deepClone(item);
        // this.saleOrder.totalAmount = utils.exchangePercent(this.saleOrder.totalAmount);
        if (res.data.data.saleBuyerInfo) {
          this.saleBuyerInfo = res.data.data.saleBuyerInfo;
        // this.saleBuyerInfo.buyerGender = this.gender[this.saleBuyerInfo.buyerGender];
        // console.log(this.saleBuyerInfo.buyerGender);
        }
        if (res.data.data.salePrescription) {
          // const prescriptionResult = [];
          // const prescriptionItem = res.data.data.salePrescription;
          // utils.exchangeTable(prescriptionItem, prescriptionResult);
          // prescriptionResult.loading = false;
          this.salePrescription = res.data.data.salePrescription;

          // console.log(12312312);
          if (res.data.data.saleUsageList) {
            this.salePrescription.saleUsageList = res.data.data.saleUsageList;
          }
        }
        let number = 1;
        res.data.data.saleOrderDetailList.forEach((orderDetail) => {
          const detailResult = {};
          utils.exchangeTable(orderDetail, detailResult);
          // console.log(detailResult);

          detailResult.number = number++;
          detailResult.createTime = utils.exchangeTimeToSecond(detailResult.createTime);
          detailResult.isRX = this.bool[detailResult.isRX];
          detailResult.isEphedrine = this.bool[detailResult.isEphedrine];
          // detailResult.price /= 100;
          // detailResult.realPrice /= 100;
          // detailResult.outputTaxRate /= 100;
          // detailResult.amount /= 100;
          // detailResult.taxFreeAmount /= 100;
          detailResult.outputTaxRate += '%';

          this.tableData.push(detailResult);
        });
      }).catch((err) => {
        utils.handleError(err);
      });
    },

  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.getPayment().then(() => {
      this.getInfo(this.approvalParams.businessUrl);
    });
  },
};
</script>
<style lang="less" scoped>
  .cardContainer{
    margin-bottom: 16px;
  }
</style>
